var map = {
	"./mark_P1.png": "1c7w",
	"./mark_P2.png": "njtQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+ZWh";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST ^\.\/mark_.*\.png$
// module id = +ZWh
// module chunks = 3